<template>
    <div>
        <Icon :item="item" @open="chooseIcon" :key="item.icon" />
        <b-sidebar v-model="showSidebar" right backdrop>
            <b-row class="side px-4 py-2">
                <b-input type="search" v-model="search" :placeholder="$t('search')" class="mb-3" />
                <b-col cols="2" v-for="icon in allIcons" :key="icon" class="ml-2 mb-2 icon" @click="choose(icon)">
                    <i :class="'icon bi bi-' + icon"></i>
                </b-col>
            </b-row>
        </b-sidebar>
    </div>
</template>

<script>
import Icon from "@/views/home/Icon";
import iconNames from 'bootstrap-icons/font/bootstrap-icons.json';

export default {
    components: {
        Icon
    },

    props: {
        item: {
            type: Object,
        }
    },

    data: function() {
        return {
            icons: [],
            showSidebar: false,
            search: null
        }
    },

    computed: {
        allIcons() {
            return this.search
                ? this.icons.filter(icon => icon.toLowerCase().includes(this.search.toLowerCase()))
                : this.icons;
        }
    },

    methods: {
        chooseIcon() {
            this.showSidebar = true
        },

        choose(icon) {
            this.$emit("input", icon);
            this.showSidebar = false;
        }
    },

    mounted() {
        this.icons = Object.keys(iconNames);
    }
};
</script>

<style scoped lang="scss">

.icon {
    background-color: var(--form-bg);
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 5px;
    border-radius: 15px;
    cursor: pointer;

    &:hover {
        color: #ccc;
        box-shadow: none;
    }

    &::before {
        font-size: 25px;
    }
}
</style>